import { Component, inject } from '@angular/core';
import { LpImgComponent } from '@gametailors/leerplus';
import { RidHomeworkService } from '../../services/rid-homework.service';

@Component({
  selector: 'rid-assignment-background',
  imports: [LpImgComponent],
  templateUrl: './rid-assignment-background.html',
})
export class RidAssignmentBackground {
  protected readonly $ridHomeworkService = inject(RidHomeworkService);
}
